var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { NotifyPropertyChangedBase } from '../../../../utilities/reflection';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { NotificationClientService, NotificationType } from '../../../../services/basics/notification-client.service';
import { CacheManagmentClientService } from '../../../../services/cache-management/cache-management-client.service';
var ManageSystemConfiguration = /** @class */ (function (_super) {
    __extends(ManageSystemConfiguration, _super);
    function ManageSystemConfiguration(cacheManagementClientService, i18N, router, notificationService) {
        var _this = _super.call(this) || this;
        _this.cacheManagementClientService = cacheManagementClientService;
        _this.i18N = i18N;
        _this.router = router;
        _this.notificationService = notificationService;
        _this.canFlushCache = true;
        return _this;
    }
    ManageSystemConfiguration.prototype.flushCache = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.cacheManagementClientService
                .flushCache()
                .then(function (response) {
                _this.notificationService.show(_this.i18N.tr('successfully-flushed-text'), _this.i18N.tr('cache-has-been-successfully-flushed-text'), NotificationType.Success);
                resolve();
            })
                .catch(function (ex) {
                _this.notificationService.show(_this.i18N.tr('error-while-flushing-text'), _this.i18N.tr('error-while-flushing-cache-text'), NotificationType.Error);
                reject();
            });
        });
    };
    ManageSystemConfiguration = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [CacheManagmentClientService, I18N,
            Router, NotificationClientService])
    ], ManageSystemConfiguration);
    return ManageSystemConfiguration;
}(NotifyPropertyChangedBase));
export { ManageSystemConfiguration };
